import { createFileRoute, Navigate, Outlet, useRouterState } from "@tanstack/react-router";
import { Shell } from "@/components/Shell";
import { useAuth } from "@/lib/auth";

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
});

function AdminLayout() {
  const { session, initializing } = useAuth();
  const path = useRouterState({ select: (s) => s.location.pathname });
  // Login is a public page — public Shell (no admin sidebar), no session guard.
  if (path === "/admin/login") {
    return (
      <Shell variant="public">
        <Outlet />
      </Shell>
    );
  }
  if (initializing) {
    return (
      <Shell variant="admin">
        <div className="mx-auto max-w-md py-24 text-center text-sm text-muted-foreground">Loading…</div>
      </Shell>
    );
  }
  if (!session || session.kind !== "admin") return <Navigate to="/login" />;
  return (
    <Shell variant="admin">
      <Outlet />
    </Shell>
  );
}
